export const CandidateDetailLanguageMode = {
    EXTRACT: "extract",
    DETAIL: "detail",
    SEARCH: "search",
    RC: "rc",
    SEARCH_RC: "search_rc"
}